import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

import * as ReduxUtils from "../../lib/util/ReduxUtils";
import * as DriverIndexActions from "./DriverIndex.action";
import { UserStatusTypeId } from "../../lib/types/UserTypes";
import { DriverSort } from "./DriverIndex";

export interface DriverIndexReducerState {
	statusId: UserStatusTypeId | "all" | null;
	sortedBy: DriverSort;
	remindDriver: AsyncState<any>;
	updateInvite: AsyncState<any>;
	retryInvite: AsyncState<any>;
	removeInvite: AsyncState<any>;
	bulkRemind: AsyncState<any>;
}

const initialState: DriverIndexReducerState = {
	statusId: null,
	sortedBy: [["lastScoreableJourney", "signedUp", "lastInviteSent"], "desc"],
	remindDriver: AsyncState.create([]),
	updateInvite: AsyncState.create([]),
	retryInvite: AsyncState.create([]),
	removeInvite: AsyncState.create([]),
	bulkRemind: AsyncState.create([]),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<DriverIndexReducerState>({
		remindDriver: DriverIndexActions.remindDriver.type,
		updateInvite: DriverIndexActions.updateInvite.type,
		retryInvite: DriverIndexActions.retryInvite.type,
		removeInvite: DriverIndexActions.removeInvite.type,
		bulkRemind: DriverIndexActions.bulkRemind.type,
	}),
	ReduxUtils.createReducerMap({
		[DriverIndexActions.setFilterSelection.type]: (state, action) => {
			return {
				...state,
				statusId: action.payload,
			};
		},

		[DriverIndexActions.setSortSelection.type]: (state, action) => {
			return Object.assign({}, state, {
				sortedBy: action.payload,
			});
		},
	}),
]);
